function hasPermission(permissions, parentModule, childModule = null, permission) {
  const parent = permissions?.find(mod => mod.module_name === parentModule);
  const moduleData = childModule ? parent?.children?.find(child => child.module_name === childModule) : parent;
  return moduleData?.[`can_${permission}`] ?? false;
}
// Activity
export const hasDashboardPermission = (permissions, permission) =>
  hasPermission(permissions, "Dashboard", null, permission);

export const hasActivityPermission = (permissions, permission) =>
  hasPermission(permissions, "Activities", null, permission);
  
// Sales Production
export const hasDeveloperPermission = (permissions, permission) =>
  hasPermission(permissions, "Sales Production", "Developer", permission);

export const hasProjectPermission = (permissions, permission) =>
  hasPermission(permissions, "Sales Production", "Projects/Properties", permission);
  
// Services
export const hasServicePermission = (permissions, permission) =>
  hasPermission(permissions, "Services", "Service List", permission);

export const hasRatePermission = (permissions, permission) => 
  hasPermission(permissions, "Rate Profile", permission);
  //
export function hasServicesPermission(permissions, module, permission) {
  const moduleData = permissions?.find(mod => mod.module_name === "Services")
    ?.children?.find(child => child.module_name === module);
  return moduleData ? moduleData[`can_${permission}`] ?? false : false;
}

export const hasDocumentationPermission = (permissions, permission) =>
  hasPermission(permissions, "Services", "Documentations List", permission);

// Settings
export const hasStaffPermission = (permissions, permission) =>
  hasPermission(permissions, "Systems", "System Users", permission);

export const hasStaffRolePermission = (permissions, permission) =>
  hasPermission(permissions, "Systems", "Staff Roles", permission);

export const hasModulesPermission = (permissions, permission) =>
  hasPermission(permissions, "Systems", "System Modules", permission);

export const hasAccountsPermission = (permissions, permission) =>
  hasPermission(permissions, "Sales Production", "Account Data", permission);